/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'gatsby';

import trainingDateFormat from 'utils/trainingDateFormat';
import { getTrainingTime } from 'utils/dateTimeFormat';

import { Item } from './TrainingArchiveItem.styled';

const TrainingArchiveItem = ({ data }) => {
  const seatsLeft = data.batchSize - data.enrollmentCount;
  const daysLeft = moment(moment(data.startDate)).diff(
    moment().format('YYYY-MM-DD'),
    'days',
    true,
  );

  function createLocation(_data) {
    return { __html: _data.location };
  }

  return (
    <Item className="d-flex flex-wrap">
      <div className="pt-20">
        <div className="date bold">{trainingDateFormat(data)}</div>

        {data && data.trainingId.startsWith('AC') ? (
          <span className="time">(Weekends Only)</span>
        ) : (
          ''
        )}
        <br />
        <span className="time">{getTrainingTime(data)}</span>
        <br />
        <span
          className="location bold"
          dangerouslySetInnerHTML={createLocation(data)}
        />
      </div>
      <div className="center pt-20">
        <div className="speaker-images-wrapper">
          {/* <Image
          src={trainings[0].speakerImage}
          style={{ height: 132, width: 132 }}
          className="speaker-image"
        /> */}
        {/* {console.log(data)}   */}
        { data.trainingId.startsWith('PMP')?
        <a href="https://www.pmi.org/certifications/project-management-pmp" target="_blank"> 
          <img
            src={data.badge}
            style={
              data && data.trainingId.startsWith('ATC')
                ? { height: '100%', width: 90, marginTop: 5 }
                : { height: 132, width: 132 }
            }
            className="speaker-image"
            alt="badge"
          />
           </a>:<img
            src={data.badge}
            style={
              data && data.trainingId.startsWith('ATC')
                ? { height: '100%', width: 90, marginTop: 5 }
                : { height: 132, width: 132 }
            }
            className="speaker-image"
            alt="badge"
          />
        }
        </div>
        {/* <span className="speaker-title bold">Keynote Speaker</span>
      <br />
      <span className="speaker-name">Speaker name missing</span> */}
      </div>
      <div className="pt-20">
        {/* <span
        className="subtitle bold"
        dangerouslySetInnerHTML={{ __html: data.courseStatus }}
      />
      <br /> */}
        <span
          className="title bold"
          dangerouslySetInnerHTML={{ __html: data.courseName }}
        />
        <br></br>
        <span className="course-description">{data.courseExpansion}</span>
      </div>
      {!data.enrollmentClosed ? (
        <>
          <div className="center">
            <div style={{ minHeight: 25 }}>
              {new Date(data.discountEndDate) > new Date() ? (
                <span className="early-bird">
                  Early Bird Discount Available
                </span>
              ) : null}
            </div>
            <div className="seats-count">
              {seatsLeft > 0 && seatsLeft < 8
                ? `${seatsLeft} seats left`
                : daysLeft <= 30
                ? 'Few Seats Left'
                : ''}
            </div>
            <Link
              to={`/checkout/${data.trainingId}`}
              className="pink-btn"
              style={{ minWidth: 166 }}
            >
              <span className="white">Register Now</span>
            </Link>
            <br />
            <Link
              to={`/trainings/course-content/${data.trainingId}`}
              className="more-info-link bold"
            >
              More Info
            </Link>
          </div>
        </>
      ) : (
        <>
          <div>
            <div
              style={{ height: 46, width: 166, marginLeft: 25, marginTop: 70 }}
              className="fully-booked"
            >
              <label>Fully Booked</label>
            </div>
          </div>
        </>
      )}
    </Item>
  );
};

TrainingArchiveItem.propTypes = {
  data: PropTypes.object.isRequired,
};

export default TrainingArchiveItem;
